var _defs, _path, _path2, _polyline, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternalStandardsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.93 129.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-linejoin:round;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-width:5px;}.cls-1,.cls-2,.cls-3{stroke:#11ccea;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-3{fill:#11ccea;stroke-width:.75px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m99.3,27.53v85.5c0,10.8-5.1,15.8-15.9,15.8H16.1c-9.9,0-15.1-5.2-15.1-15.2,0-2.6.1-5.1,0-7.7s1.1-3.6,3.6-3.5c5.7.1,11.3,0,17,0,.5,0,1.1-.1,2.1-.2V16.53c0-10.7,5.1-15.7,15.8-15.7h67.7c9.7,0,15,5.4,15,15.1,0,2.7-.1,5.3,0,8,.1,2.5-1,3.4-3.4,3.4-5.1-.1-10.2,0-15.3,0-1.4,0-2.6.1-4.2.2ZM27.4,102.43h45.4c2.8,0,4.1.9,3.9,3.9-.2,3.2-.1,6.4,0,9.7.2,5,3.8,8.7,8.5,9.1,4.7.4,8.8-2.6,9.9-7.5.4-1.6.4-3.3.4-5V23.33c0-6.2-1.3-12.7,3.5-18.6h-59.7c-8.6,0-11.9,3.3-11.9,11.8v82c0,1.1,0,2.3,0,3.9Zm-22.7,3.8v4.4c0,2.1-.1,4.2.2,6.3.7,4.9,4.6,8.1,9.5,8.1h57.7c1.2,0,2.3-.1,4.3-.2-4.2-4.6-3.8-9.7-3.6-14.7.1-3-.7-4-3.8-3.9-20.1.1-40.2.1-60.3.1-1.2-.1-2.3-.1-4-.1ZM99.3,23.53c6,0,11.5,0,17-.1.6,0,1.6-1,1.6-1.5,0-3.5.2-7.1-.5-10.5-.9-4.4-5.3-7.1-9.8-6.7-4.4.4-7.9,3.7-8.3,8.1-.2,3.4,0,6.8,0,10.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.9,24.73l21.9-14.2,21.4,12.3-8.6,29.7s-6.5,5.5-13.1,5.3-13.1-6.2-13.1-6.2l-8.5-26.9Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "51.4 39.33 58.6 45.13 70.7 24.03"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.8,
    y1: 67.53,
    x2: 82.9,
    y2: 67.53
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.6,
    y1: 79.03,
    x2: 82.7,
    y2: 79.03
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.4,
    y1: 90.93,
    x2: 82.5,
    y2: 90.93
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalStandardsIcon);
export default __webpack_public_path__ + "static/media/internal_standards_icon.df940b58562aeff058948b06be4b9df4.svg";
export { ForwardRef as ReactComponent };